(() => {
  if (window.__greenShineCommerceV4Ready) return;
  window.__greenShineCommerceV4Ready = true;

  const publish = (eventName, payload) => {
    try {
      const result = window.Shopify?.analytics?.publish?.(eventName, payload);
      if (result && typeof result.catch === 'function') result.catch(() => {});
    } catch (error) {
      // Navigation and native Shopify commerce must never be blocked by analytics.
    }
  };

  const contextFor = (element) => {
    const hub = element.closest('[data-gs-contact-hub]');
    const productRoot = element.closest('[data-gs-product-template]');
    return {
      channel: element.dataset.gsChannel || '',
      destination: element.dataset.gsDestination || '',
      context: hub?.dataset.gsContext || document.body.dataset.template || '',
      locale: hub?.dataset.gsLocale || document.documentElement.lang || '',
      product_handle: element.dataset.gsProduct || hub?.dataset.gsProduct || productRoot?.dataset.gsProductHandle || '',
      page_location: window.location.href.split('#')[0]
    };
  };


  const productHub = document.querySelector('[data-gs-contact-hub][data-gs-context="product"]');
  const purchasePanel = document.getElementById('gs-product-purchase');
  if (productHub && purchasePanel) {
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    let hubSyncQueued = false;

    const setHubActive = (active) => {
      productHub.classList.toggle('is-active', active);
      productHub.setAttribute('aria-hidden', active ? 'false' : 'true');
      productHub.toggleAttribute('inert', !active);
    };

    const syncProductHub = () => {
      if (!mobileQuery.matches) {
        productHub.classList.remove('gs-contact-hub--product-delayed', 'is-active');
        productHub.removeAttribute('aria-hidden');
        productHub.removeAttribute('inert');
        return;
      }

      productHub.classList.add('gs-contact-hub--product-delayed');
      setHubActive(purchasePanel.getBoundingClientRect().bottom < 96);
    };

    const requestProductHubSync = () => {
      if (hubSyncQueued) return;
      hubSyncQueued = true;
      requestAnimationFrame(() => {
        hubSyncQueued = false;
        syncProductHub();
      });
    };

    window.addEventListener('scroll', requestProductHubSync, { passive: true });
    window.addEventListener('resize', requestProductHubSync, { passive: true });
    mobileQuery.addEventListener?.('change', requestProductHubSync);
    syncProductHub();
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const actionElement = event.target.closest('[data-gs-action]');
    if (!actionElement) return;
    const eventNames = {
      contact_click: 'greenshine_contact_click',
      quote_click: 'greenshine_quote_click',
      social_click: 'greenshine_social_click',
      technical_details_click: 'greenshine_technical_details_click',
      product_select: 'greenshine_product_select',
      product_purchase_navigate: 'greenshine_product_purchase_navigate'
    };
    const eventName = eventNames[actionElement.dataset.gsAction];
    if (eventName) publish(eventName, contextFor(actionElement));
  });

  document.addEventListener('submit', (event) => {
    if (!(event.target instanceof Element)) return;
    const form = event.target.closest('form[data-gs-native-product-form="true"]');
    if (!form) return;
    const root = form.closest('[data-gs-product-template]');
    const variant = form.querySelector('[name="id"]');
    const quantity = form.querySelector('[name="quantity"]');
    publish('greenshine_buy_intent', {
      context: 'product',
      locale: document.documentElement.lang || '',
      product_handle: root?.dataset.gsProductHandle || '',
      variant_id: variant?.value || '',
      quantity: quantity?.value || '1',
      page_location: window.location.href.split('#')[0]
    });
  });
})();
